import {UserCell, RSVP} from '@molecules';
import {differenceInDays} from 'date-fns';
import {useTranslation} from 'react-i18next';
import {Member} from './useReservationDetails';

export const MemberCell = ({member}: {member: Member}) => {
  const {t} = useTranslation();

  const rsvpStatus = member.isOrganizer
    ? 'Organizer'
    : member.reservation.status === 'Confirmed'
    ? 'Accepted'
    : member.reservation.status === 'InvitationPending'
    ? 'Pending'
    : 'Declined';

  // TODO: is this the right setting? Should be embedded in the dto?
  const PENDING_TIMEOUT_DAYS = 5;
  const daysToRSVP = PENDING_TIMEOUT_DAYS - differenceInDays(new Date(member.reservation.createdOn), new Date());

  const subtitle =
    member.reservation.status === 'Confirmed'
      ? member.reservation.workspace.nodeName
      : member.reservation.status !== 'InvitationPending'
      ? undefined
      : daysToRSVP < 0
      ? `TODO: Expired label? - ${member.reservation.workspace.nodeName}`
      : daysToRSVP === 0
      ? t('workplace:FinalDayToRespond')
      : t('workplace:DayToRespond', {count: daysToRSVP});

  return (
    <UserCell
      separator={false}
      padding="small"
      user={member.isCurrentUser ? {...member.owner, displayName: t('translation:You')} : member.owner}
      right={<RSVP rsvp={rsvpStatus} />}
      subtitle={subtitle}
    />
  );
};
